import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useEffect } from "react";
import { FiEdit } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForAll from "../../components/common/ButtonForAll";
import {
  createHotelSpecialRate,
  deleteHotelSpecialRate,
  getAllActiveHotelRoomCategory,
  getHotelByID,
  updateHotelSpecialRate,
} from "./services/hotel.services";
import ShadowCard from "../../components/common/ShadowCard";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearHotelSpecialRateID, setHotelSpecialRateID } from "./hotelSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import moment from "moment";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import RippleButton from "../../components/common/RippleButton";
import IconButton from "../../components/common/IconButton";
import { getAllActiveFestivals } from "../festival/services/festivals.services";
import { IFestivals } from "../festival/festivalsModel";
import { getAllActiveMealTypes } from "../mealtype/services/mealtype.services";
import { IMealType } from "../mealtype/mealtypeModel";

interface SpecialRateChangeWatcherProps {
  formRenderProps: FormRenderProps;
  handleClearSpecialRateDetails: any;
}

const SpecialRateChangeWatcher: React.FC<SpecialRateChangeWatcherProps> = ({
  formRenderProps,
  handleClearSpecialRateDetails,
}) => {
  const HotelDetail = useAppSelector((state) => state.hotel.HotelDetail);

  useEffect(() => {
    handleClearSpecialRateDetails(formRenderProps);
  }, [HotelDetail]);

  return null;
};

const CreateHotelSpecialRate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const HotelID = location.state?.HotelID;
  const HotelSpecialRateDetails = useAppSelector(
    (state) => state.hotel.HotelSpecialRateDetails
  );
  const ActiveHotelRoomCategoryList = useAppSelector(
    (state) => state.hotel.ActiveHotelRoomCategoryList
  );
  const MealTypeList = useAppSelector((state) => state.mealType.MealTypeList);
  const HotelDetail = useAppSelector((state) => state.hotel.HotelDetail);
  const FestivalsList = useAppSelector(
    (state) => state.festivals.FestivalsList
  );

  useEffect(() => {
    dispatch(getAllActiveHotelRoomCategory({ HotelID: HotelID }));
    dispatch(getAllActiveFestivals());
    dispatch(getAllActiveMealTypes());
    // dispatch(getAllActiveHotelRoomCategory());
  }, []);

  const MyEditHotelCommandCell = (
    props: any,
    formRenderProps: FormRenderProps
  ) => {
    const handleEdit = (e: any, item: any) => {
      e.stopPropagation();
      formRenderProps.onChange("hotel_special_rate_id", {
        value: item?.ID,
      });
      formRenderProps.onChange("DateType", {
        value: item?.DateType,
      });
      formRenderProps.onChange("RoomCategoryID", {
        value: item?.RoomCategoryID,
      });
      formRenderProps.onChange("FestivalID", {
        value: item?.FestivalID,
      });
      formRenderProps.onChange("FromDate", {
        value: item?.FromDate
          ? moment(item?.FromDate, "DD/MM/YYYY").toDate()
          : "",
      });
      formRenderProps.onChange("ToDate", {
        value: item?.ToDate ? moment(item?.ToDate, "DD/MM/YYYY").toDate() : "",
      });
      formRenderProps.onChange("MealID", {
        value: item?.MealID,
      });
      formRenderProps.onChange("MarkupType", {
        value: item?.MarkupType,
      });
      formRenderProps.onChange("MarkupAmount", {
        value: item?.MarkupAmount,
      });
      formRenderProps.onChange("SingleOccupancyRate", {
        value: item?.SingleOccupancyRate || 0,
      });
      formRenderProps.onChange("DoubleOccupancyRate", {
        value: item?.DoubleOccupancyRate || 0,
      });
      formRenderProps.onChange("ExtraPersonRate", {
        value: item?.ExtraPersonRate || 0,
      });
      formRenderProps.onChange("ChildWithBedRate", {
        value: item?.ChildWithBedRate || 0,
      });
      formRenderProps.onChange("ChildWithoutBedRate", {
        value: item?.ChildWithoutBedRate || 0,
      });
      // formRenderProps.onChange("SOEPAI", {
      //   value: item?.SOEPAI || 0,
      // });
      // formRenderProps.onChange("SOCPAI", {
      //   value: item?.SOCPAI || 0,
      // });
      // formRenderProps.onChange("SOMAPAI", {
      //   value: item?.SOMAPAI || 0,
      // });
      // formRenderProps.onChange("SOAPAI", {
      //   value: item?.SOAPAI || 0,
      // });
      formRenderProps.onChange("KitchenCharges", {
        value: item?.KitchenCharges || 0,
      });
      formRenderProps.onChange("IsActive", {
        value: item?.IsActive === true ? 1 : 2,
      });
    };

    const handleOpenDeleteDialog = (e: any, ID: number) => {
      e.stopPropagation();
      dispatch(openDialog("deleteHotelSpecialRate"));
      dispatch(setHotelSpecialRateID(ID));
    };

    return (
      <td
        className={props.className}
        style={{
          ...props.style,
          textAlign: "center",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          themeColor={"primary"}
          style={{ height: 35, width: 35 }}
          onClick={(e: any) => handleEdit(e, props)}
          icon={FiEdit}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />

        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          className="color-red"
          style={{ height: 35, width: 35 }}
          onClick={(e: any) => handleOpenDeleteDialog(e, props.ID)}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const handleClearSpecialRateDetails = (formRenderProps: FormRenderProps) => {
    formRenderProps.onChange("hotel_special_rate_id", {
      value: "",
    });
    formRenderProps.onChange("DateType", {
      value: null,
    });
    formRenderProps.onChange("RoomCategoryID", {
      value: null,
    });
    formRenderProps.onChange("FestivalID", {
      value: "",
    });
    formRenderProps.onChange("FromDate", {
      value: "",
    });
    formRenderProps.onChange("ToDate", {
      value: "",
    });
    formRenderProps.onChange("MealID", {
      value: null,
    });
    formRenderProps.onChange("MarkupType", {
      value: "",
    });
    formRenderProps.onChange("MarkupAmount", {
      value: 0,
    });
    formRenderProps.onChange("SingleOccupancyRate", {
      value: 0,
    });
    formRenderProps.onChange("DoubleOccupancyRate", {
      value: 0,
    });
    formRenderProps.onChange("ExtraPersonRate", {
      value: 0,
    });
    formRenderProps.onChange("ChildWithBedRate", {
      value: 0,
    });
    formRenderProps.onChange("ChildWithoutBedRate", {
      value: 0,
    });
    // formRenderProps.onChange("SOEPAI", {
    //   value: 0,
    // });
    // formRenderProps.onChange("SOCPAI", {
    //   value: 0,
    // });
    // formRenderProps.onChange("SOMAPAI", {
    //   value: 0,
    // });
    // formRenderProps.onChange("SOAPAI", {
    //   value: 0,
    // });
    formRenderProps.onChange("KitchenCharges", {
      value: 0,
    });
    formRenderProps.onChange("IsActive", {
      value: 1,
    });
  };

  const handleSubmit = async (values: any) => {
    try {
      if (!values?.hotel_special_rate_id) {
        const insertPayload = {
          HotelID: HotelID ? HotelID : null,
          DateType: values?.DateType ? +values?.DateType : null,
          RoomCategoryID: values?.RoomCategoryID
            ? +values?.RoomCategoryID
            : null,
          FestivalID: values?.FestivalID ? +values?.FestivalID : null,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : null,
          MealID: values?.MealID ? +values?.MealID : null,
          MarkupType: values?.MarkupType ? values?.MarkupType : "₹",
          MarkupAmount: values?.MarkupAmount ? +values?.MarkupAmount : null,
          SingleOccupancyRate: values?.SingleOccupancyRate
            ? +values?.SingleOccupancyRate
            : null,
          DoubleOccupancyRate: values?.DoubleOccupancyRate
            ? +values?.DoubleOccupancyRate
            : null,
          ExtraPersonRate: values?.ExtraPersonRate
            ? +values?.ExtraPersonRate
            : null,
          ChildWithBedRate: values?.ChildWithBedRate
            ? +values?.ChildWithBedRate
            : null,
          ChildWithoutBedRate: values?.ChildWithoutBedRate
            ? +values?.ChildWithoutBedRate
            : null,
          // SOEPAI: values?.SOEPAI ? +values?.SOEPAI : null,
          // SOCPAI: values?.SOCPAI ? +values?.SOCPAI : null,
          // SOMAPAI: values?.SOMAPAI ? +values?.SOMAPAI : null,
          // SOAPAI: values?.SOAPAI ? +values?.SOAPAI : null,
          KitchenCharges: values?.KitchenCharges
            ? +values?.KitchenCharges
            : null,
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createHotelSpecialRate(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getHotelByID(HotelID));
        }
      } else {
        const updatePayload = {
          ID: values?.hotel_special_rate_id
            ? values?.hotel_special_rate_id
            : null,
          HotelID: HotelID ? HotelID : null,
          DateType: values?.DateType ? +values?.DateType : null,
          RoomCategoryID: values?.RoomCategoryID
            ? +values?.RoomCategoryID
            : null,
          FestivalID: values?.FestivalID ? +values?.FestivalID : null,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : null,
          MealID: values?.MealID ? +values?.MealID : null,
          MarkupType: values?.MarkupType ? values?.MarkupType : "₹",
          MarkupAmount: values?.MarkupAmount ? +values?.MarkupAmount : null,
          SingleOccupancyRate: values?.SingleOccupancyRate
            ? +values?.SingleOccupancyRate
            : null,
          DoubleOccupancyRate: values?.DoubleOccupancyRate
            ? +values?.DoubleOccupancyRate
            : null,
          ExtraPersonRate: values?.ExtraPersonRate
            ? +values?.ExtraPersonRate
            : null,
          ChildWithBedRate: values?.ChildWithBedRate
            ? +values?.ChildWithBedRate
            : null,
          ChildWithoutBedRate: values?.ChildWithoutBedRate
            ? +values?.ChildWithoutBedRate
            : null,
          // SOEPAI: values?.SOEPAI ? +values?.SOEPAI : null,
          // SOCPAI: values?.SOCPAI ? +values?.SOCPAI : null,
          // SOMAPAI: values?.SOMAPAI ? +values?.SOMAPAI : null,
          // SOAPAI: values?.SOAPAI ? +values?.SOAPAI : null,
          KitchenCharges: values?.KitchenCharges
            ? +values?.KitchenCharges
            : null,
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(updateHotelSpecialRate(updatePayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getHotelByID(HotelID));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      <DeleteHotelSpecialRateDialog />
      <Form
        initialValues={HotelSpecialRateDetails}
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard
              style={{
                padding: 10,
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              <GridLayout
                cols={[{ width: "100%" }]}
                style={{ marginBottom: 20 }}
              >
                <GridLayoutItem>
                  <Typography.h4 className="text-dark">
                    {"Hotel Special Rate"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <GridLayout
                    gap={{ rows: 0, cols: "0.5%" }}
                    cols={[
                      { width: "32%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="DateType"
                        placeholder="Date Type"
                        label="Date Type"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={[
                          { label: "Special Rate", value: 1 },
                          { label: "Weekdays", value: 2 },
                          { label: "Weekend", value: 3 },
                          { label: "Regular Days", value: 4 },
                        ]}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="RoomCategoryID"
                        placeholder="Room Category"
                        label="Room Category"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={ActiveHotelRoomCategoryList?.map(
                          (status: any) => {
                            return {
                              value: status?.ID,
                              label: status?.RoomCategoryName,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    {formRenderProps.valueGetter("DateType") === 1 && (
                      <GridLayoutItem style={{ width: "100%" }}>
                        <Field
                          name="FestivalID"
                          placeholder="Festival"
                          label="Festival"
                          astrike={
                            formRenderProps.valueGetter("DateType") === 1
                              ? true
                              : false
                          }
                          component={FormSelectionField}
                          validator={
                            formRenderProps.valueGetter("DateType") === 1
                              ? requiredValidator
                              : skipValidator
                          }
                          options={FestivalsList?.map((status: IFestivals) => {
                            return {
                              value: status?.ID,
                              label: status?.Title,
                            };
                          })}
                        />
                      </GridLayoutItem>
                    )}
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"FromDate"}
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        astrike={
                          formRenderProps.valueGetter("DateType") === 1
                            ? true
                            : false
                        }
                        validator={
                          formRenderProps.valueGetter("DateType") === 1
                            ? requiredValidator
                            : skipValidator
                        }
                      />
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"ToDate"}
                        label="To Date"
                        format="dd/MM/yyyy"
                        minDate={moment(
                          formRenderProps.valueGetter("FromDate")
                        ).toDate()}
                        component={FormDatePicker}
                        astrike={
                          formRenderProps.valueGetter("DateType") === 1
                            ? true
                            : false
                        }
                        validator={
                          formRenderProps.valueGetter("DateType") === 1
                            ? requiredValidator
                            : skipValidator
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="MealID"
                        placeholder="Meal"
                        label="Meal"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={MealTypeList?.map((mealtype: IMealType) => {
                          return {
                            value: mealtype?.ID,
                            label: mealtype?.MealType,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-75"
                        name="MarkupType"
                        placeholder="Markup Type"
                        label="Markup Type"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={[
                          { label: "₹", value: "₹" },
                          { label: "%", value: "%" },
                        ]}
                        onChange={(e: any) => {
                          const MarkupAmount =
                            formRenderProps.valueGetter("MarkupAmount") || 0;
                          if (e?.value === "%" && MarkupAmount > 100) {
                            formRenderProps.onChange("MarkupAmount", {
                              value: 0,
                            });
                          }
                        }}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`MarkupAmount`}
                        label="Markup Amount"
                        placeholder="0"
                        component={FormNumericTextField}
                        max={
                          formRenderProps.valueGetter("MarkupType") === "%"
                            ? 100
                            : "unset"
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`SingleOccupancyRate`}
                        label="Single Occ. Rate"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`DoubleOccupancyRate`}
                        label="Double Occ. Rate"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`ExtraPersonRate`}
                        label="Extra Per. Rate"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`ChildWithBedRate`}
                        label="CWB Rate"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`SOEPAI`}
                        label="EPAI"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`SOCPAI`}
                        label="CPAI"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem> 
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`SOMAPAI`}
                        label="MAPAI"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`SOAPAI`}
                        label="APAI"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>*/}
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`ChildWithoutBedRate`}
                        label="CNB Rate"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`KitchenCharges`}
                        label="Kitchen Charges"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        name="IsActive"
                        label="Status"
                        astrike={true}
                        validator={requiredValidator}
                        placeholder="i.e. Active"
                        component={FormSelectionField}
                        options={STATUSARRAY?.map((status: any) => {
                          return {
                            value: status?.value,
                            label: status?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={
                        formRenderProps.valueGetter("DateType") === 1 ? 2 : 3
                      }
                      style={{
                        textAlign: "end",
                        marginTop: 36,
                        paddingBottom: 20,
                        // borderBottom: "1px solid lightgray",
                      }}
                    >
                      <ButtonForAll
                        label={
                          formRenderProps.valueGetter("hotel_special_rate_id")
                            ? "Update"
                            : "Add"
                        }
                        disabled={!formRenderProps.allowSubmit}
                        type="submit"
                      />
                      <Button
                        style={{ marginLeft: 10 }}
                        fillMode={"outline"}
                        themeColor={"primary"}
                        type="button"
                        onClick={() => {
                          handleClearSpecialRateDetails(formRenderProps);
                        }}
                      >
                        Clear
                      </Button>
                      <RippleButton
                        type="button"
                        fillMode="outline"
                        themeColor="primary"
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/hotel")}
                      >
                        Cancel
                      </RippleButton>
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        borderBottom: "1px solid lightgray",
                      }}
                    ></GridLayoutItem>
                  </GridLayout>
                </GridLayoutItem>
              </GridLayout>
              {HotelDetail &&
                HotelDetail.WeekDaysRateList &&
                HotelDetail.WeekDaysRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                      }}
                    >
                      Hotel Rates (Weekdays)
                    </h5>
                    {HotelDetail.WeekDaysRateList.map(
                      (rate: any, index: number) => (
                        <div
                          style={{
                            background: "#e5f4ff",
                            padding: "12px 16px",
                            fontWeight: "500",
                            color: "#000",
                            marginBottom: 15,
                          }}
                          key={index}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  Category:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.RoomCategoryName}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  From Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.FromDate}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  To Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ToDate}
                                </div>
                              </td>
                              <td style={{ width: "10%" }} rowSpan={4}>
                                {MyEditHotelCommandCell(rate, formRenderProps)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Meal:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.Meal || "-"}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Markup:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.MarkupAmount || 0}{" "}
                                  {rate?.MarkupType === "%"
                                    ? rate?.MarkupType
                                    : ""}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Single Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.SingleOccupancyRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Double Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.DoubleOccupancyRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Extra Adult Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ExtraPersonRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CWB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithBedRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CNB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithoutBedRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Kitchen Charges:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.KitchenCharges || 0}
                                </div>
                              </td>
                              <td></td>
                            </tr>
                          </table>
                        </div>
                      )
                    )}
                  </>
                )}
              {HotelDetail &&
                HotelDetail.WeekEndRateList &&
                HotelDetail.WeekEndRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                      }}
                    >
                      Hotel Rates (Weekends)
                    </h5>
                    {HotelDetail.WeekEndRateList.map(
                      (rate: any, index: number) => (
                        <div
                          style={{
                            background: "#e5f4ff",
                            padding: "12px 16px",
                            fontWeight: "500",
                            color: "#000",
                            marginBottom: 15,
                          }}
                          key={index}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  Category:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.RoomCategoryName}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  From Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.FromDate}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  To Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ToDate}
                                </div>
                              </td>
                              <td style={{ width: "10%" }} rowSpan={4}>
                                {MyEditHotelCommandCell(rate, formRenderProps)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Meal:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.Meal || "-"}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Markup:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.MarkupAmount || 0}{" "}
                                  {rate?.MarkupType === "%"
                                    ? rate?.MarkupType
                                    : ""}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Single Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.SingleOccupancyRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Double Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.DoubleOccupancyRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Extra Adult Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ExtraPersonRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CWB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithBedRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CNB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithoutBedRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Kitchen Charges:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.KitchenCharges || 0}
                                </div>
                              </td>
                              <td></td>
                            </tr>
                          </table>
                        </div>
                      )
                    )}
                  </>
                )}
              {HotelDetail &&
                HotelDetail.SpecialDateRateList &&
                HotelDetail.SpecialDateRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                      }}
                    >
                      Hotel Rates (Special Rates)
                    </h5>
                    {HotelDetail.SpecialDateRateList.map(
                      (rate: any, index: number) => (
                        <div
                          style={{
                            background: "#e5f4ff",
                            padding: "12px 16px",
                            fontWeight: "500",
                            color: "#000",
                            marginBottom: 15,
                          }}
                          key={index}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  Category:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.RoomCategoryName}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  Festival:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.FestivalName}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  From Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.FromDate}
                                </div>
                              </td>
                              <td style={{ width: "10%" }} rowSpan={4}>
                                {MyEditHotelCommandCell(rate, formRenderProps)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  To Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ToDate}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Meal:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.Meal || "-"}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Markup:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.MarkupAmount || 0}{" "}
                                  {rate?.MarkupType === "%"
                                    ? rate?.MarkupType
                                    : ""}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Single Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.SingleOccupancyRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Double Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.DoubleOccupancyRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Extra Adult Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ExtraPersonRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CWB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithBedRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CNB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithoutBedRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Kitchen Charges:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.KitchenCharges || 0}
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      )
                    )}
                  </>
                )}
              {HotelDetail &&
                HotelDetail.RegularDaysRateList &&
                HotelDetail.RegularDaysRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                      }}
                    >
                      Hotel Rates (Regular Days)
                    </h5>
                    {HotelDetail.RegularDaysRateList.map(
                      (rate: any, index: number) => (
                        <div
                          style={{
                            background: "#e5f4ff",
                            padding: "12px 16px",
                            fontWeight: "500",
                            color: "#000",
                            marginBottom: 15,
                          }}
                          key={index}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  Category:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.RoomCategoryName}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  From Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.FromDate}
                                </div>
                              </td>
                              <td style={{ width: "30%" }}>
                                <div style={{ width: "50%", float: "left" }}>
                                  To Date:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ToDate}
                                </div>
                              </td>
                              <td style={{ width: "10%" }} rowSpan={4}>
                                {MyEditHotelCommandCell(rate, formRenderProps)}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Meal:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.Meal || "-"}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Markup:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.MarkupAmount || 0}{" "}
                                  {rate?.MarkupType === "%"
                                    ? rate?.MarkupType
                                    : ""}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Single Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.SingleOccupancyRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Double Occ. Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.DoubleOccupancyRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Extra Adult Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ExtraPersonRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CWB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithBedRate || 0}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  CNB Rate:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.ChildWithoutBedRate || 0}
                                </div>
                              </td>
                              <td>
                                <div style={{ width: "50%", float: "left" }}>
                                  Kitchen Charges:
                                </div>
                                <div style={{ width: "50%", float: "right" }}>
                                  {rate?.KitchenCharges || 0}
                                </div>
                              </td>
                              <td></td>
                            </tr>
                          </table>
                        </div>
                      )
                    )}
                  </>
                )}
            </ShadowCard>
            <SpecialRateChangeWatcher
              formRenderProps={formRenderProps}
              handleClearSpecialRateDetails={handleClearSpecialRateDetails}
            />
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteHotelSpecialRateDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const location = useLocation();
  const HotelID = location.state?.HotelID;

  const HotelSpecialRateID = useAppSelector(
    (state) => state.hotel.HotelSpecialRateID
  );

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteHotelSpecialRate(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getHotelByID(HotelID));
        dispatch(closeDialog());
        dispatch(clearHotelSpecialRateID());
      } else {
        dispatch(getHotelByID(HotelID));
        dispatch(closeDialog());
        dispatch(clearHotelSpecialRateID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteHotelSpecialRate" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Special Rate?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Special Rate?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(HotelSpecialRateID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default CreateHotelSpecialRate;
